<button
rds-primary-button
size="l"
routerLink="/news/create"
[disabled]="(blocked$ | async) === true"
>
Add news
</button>
